var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocaltrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.61 2c3.994 0 7.257 3.108 7.386 7l.004 15a6 6 0 0 1 -5.775 5.996l-8.225.004a6 6 0 0 1 -5.996-5.775l-.004-14.985c0-3.924 3.183-7.11 7.146-7.236zm-5.22 2c-2.907 0-5.27 2.236-5.386 5.024l-.004 14.976c0 2.142 1.678 3.974 4 4 .012-.638.595-1.033 1.141-.955a20.068 20.068 0 0 0 5.716 0c.547-.078 1.13.315 1.141.955a4 4 0 0 0 3.997-3.8l.005-14.96c0-2.816-2.29-5.122-5.167-5.236zm-.39 19a1 1 0 0 1 1 1c0 .513-.438 1-1 1h-2a1 1 0 0 1 -1-1c0-.513.407-1 1-.993zm8 0a1 1 0 0 1 1 1c0 .513-.424 1-1 1h-2a1 1 0 0 1 0-2zm-2.316-17a3.303 3.303 0 0 1 3.31 3.162c-.303 4.774-.485 7.723-.546 8.849-.091 1.688-1.254 2.893-2.826 2.984l-5.105.005c-1.601 0-2.909-1.25-2.996-2.773l-.521-8.955c.001-1.749 1.39-3.17 3.129-3.267zm-5.367 2c-.685 0-1.243.505-1.312 1.095-.007.323.165 3.33.516 9.021a1 1 0 0 0 .879.877l5.046.007c.515 0 .94-.389.998-.936l.556-8.784c.003-.66-.512-1.208-1.18-1.274z",
    fill: "#282d37",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocaltrain);
export default __webpack_public_path__ + "static/media/localtrain.5ff00a4a152fe5c202b6c8c875ea0547.svg";
export { ForwardRef as ReactComponent };